var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 21,
    viewBox: "0 0 10 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "brandico:facebook",
    clipPath: "url(#clip0_1113_840)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.55277 20.3145L2.55277 10.9299H0L0 7.55097H2.55277L2.55277 4.66495C2.55277 2.39709 4.0607 0.314453 7.53529 0.314453C8.9421 0.314453 9.98237 0.445553 9.98237 0.445553L9.9004 3.60087C9.9004 3.60087 8.83949 3.59083 7.68178 3.59083C6.42879 3.59083 6.22804 4.15213 6.22804 5.08375V7.55097L10 7.55097L9.83588 10.9299H6.22804L6.22804 20.3145H2.55277Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1113_840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 20,
    fill: "white",
    transform: "translate(0 0.314453)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhite);
export default __webpack_public_path__ + "static/media/facebook-white.fb294386c1aad410d1610d92f24ae396.svg";
export { ForwardRef as ReactComponent };